var map = {
	"./instrument-acousticguitar.jpg": 4223,
	"./instrument-bass.jpg": 8447,
	"./instrument-drums.jpg": 1040,
	"./instrument-electricguitar.jpg": 8974,
	"./instrument-keyboard.jpg": 7783,
	"./instrument-piano.jpg": 9282,
	"./instrument-trumpet.jpg": 2247,
	"./instrument-ukulele.jpg": 1205,
	"./instrument-violin.jpg": 5930,
	"./instrument-vocals.jpg": 6938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2504;